import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';

function Header() {
  return (
    <>
      <h3 className="px-4 pt-4 text-xl font-semibold">
        <T kind="Invite to Collection" />
      </h3>
      <p className="px-4 pb-4 text-sm">
        <T kind="Confirm the invitation schedule for the selected participants." />
      </p>
    </>
  );
}

export default observer(Header);
